import { render } from "./CompanyInformationModal.vue?vue&type=template&id=6883bd02&scoped=true"
import script from "./CompanyInformationModal.vue?vue&type=script&lang=js"
export * from "./CompanyInformationModal.vue?vue&type=script&lang=js"

import "./CompanyInformationModal.vue?vue&type=style&index=0&id=6883bd02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6883bd02"]])

export default __exports__